import axios from 'axios'

const state = {
    employees: {},
    employeesFromDevice: [],
    employee: {},
    isLoadingTable: false,
    showDeleteModal: false
}

const mutations = {
    getPaginatedEmployees(state, payload) {
        state.isLoadingTable = true
        let branchId = 0; // default 0 = all employees without branch restrictions
 
        if(payload.branchId){
            if(payload.branchId != 0){
                branchId = payload.branchId;
            }
        }
        
        axios.get(`api/employees/page=${payload.page}&pageSize=${payload.pageSize}/includeInactive=${payload.includeInactive}/branchId=${branchId}/${payload.query}`)
            .then(response => {
                state.employees = response.data
            }).catch(error => {
                // eslint-disable-next-line no-console
                console.log(error);
            }).then(() => {
                state.isLoadingTable = false
            })
    },
    getEmployeesFromDevice(state) {
        axios.get(`api/employees/device`).then(response => {
            state.employeesFromDevice = response.data
        }).catch(error => {
            console.log(error)
        })
    },
    openDeleteModal(state, payload) {
        state.showDeleteModal = payload.showDeleteModal
        if (payload.showDeleteModal) {
            state.employee = payload.employee
        } else {
            state.employee = {}
        }
    },
}

const actions = {
    getPaginatedEmployees({
        commit
    }, payload) {
        commit("getPaginatedEmployees", payload)
    },
    getEmployeesFromDevice({commit}){
        commit("getEmployeesFromDevice")
    },
    openDeleteModal({
        commit
    }, payload) {
        commit("openDeleteModal", payload)
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}